import styled from 'styled-components';

export const Container = styled.div`
  overflow: hidden;

  [data-placeholder]::before {
    color: transparent;
    border-radius: 4px;
    content: attr(data-placeholder);
    background: ${({ theme }) => theme.palette.common.PLACEHOLDER};
  }
`;
